import { DeploymentVersionService } from '../services/deployment-version.service';
import { EnvironmentsService } from '../services/environments.service';
import { NewAppVersionService } from '../services/new-app-version.service';

export function environmentsInitializer(
  environmentsService: EnvironmentsService,
  deploymentVersionService: DeploymentVersionService,
  newAppVersionService: NewAppVersionService,
): () => Promise<any> {
  return () =>
    Promise.all([environmentsService.loadConfig(), deploymentVersionService.run(), newAppVersionService.init()]);
}
